export default class Service {
  constructor({ url, func }) {
    this.URL = url;
    this.treatment = func;
  }

  async get() {
    const responce = fetch(this.URL);
    const result = responce.then((e) => this.treatment(e));
    return result;
  }
}
